/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const UpdateTicketStatus = {
  Closed: "closed",
} as const;
export type UpdateTicketStatus = ClosedEnum<typeof UpdateTicketStatus>;

/** @internal */
export const UpdateTicketStatus$inboundSchema: z.ZodNativeEnum<
  typeof UpdateTicketStatus
> = z.nativeEnum(UpdateTicketStatus);
/** @internal */
export const UpdateTicketStatus$outboundSchema: z.ZodNativeEnum<
  typeof UpdateTicketStatus
> = UpdateTicketStatus$inboundSchema;
